module.exports = __webpack_public_path__ + "img/bc.3da3136b.png";